class Alerts {
    static register = {
       AL_VIEW : {slug: 'AL_VIEW'}
    };
}

export default Alerts;